module cr.events {
    export class eventSelectionCtrl {
        static $inject = ['$scope','$modalInstance','eventService' ];

        public selection:any=[];

        Select=(event)=>{
            this.$modalInstance.close(event);
        }

        Search=(toSearch)=>{
            console.log("search: "+toSearch);
            this.eventService.searchText(toSearch).then(events=>{
                this.selection=events.data;
              //  console.log("search result: "+angular.toJson(events));
            },error=>{
                console.log("error: "+angular.toJson(error));
            });
        }

        constructor(private $scope, private $modalInstance,public eventService) {


        }
    }


}
